/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Approve_RequestInputs */

const en_approve_request = /** @type {(inputs: Approve_RequestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Approve`)
};

const es_approve_request = /** @type {(inputs: Approve_RequestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aprobar`)
};

const fr_approve_request = /** @type {(inputs: Approve_RequestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Approuver`)
};

const de_approve_request = /** @type {(inputs: Approve_RequestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Genehmigen`)
};

const id_approve_request = /** @type {(inputs: Approve_RequestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Setujui`)
};

/** @type {(inputs: Approve_RequestInputs) => LocalizedString} */
const ja_approve_request = en_approve_request;

/** @type {(inputs: Approve_RequestInputs) => LocalizedString} */
const zh_approve_request = en_approve_request;

/** @type {(inputs: Approve_RequestInputs) => LocalizedString} */
const ar_approve_request = en_approve_request;

/** @type {(inputs: Approve_RequestInputs) => LocalizedString} */
const it_approve_request = en_approve_request;

/** @type {(inputs: Approve_RequestInputs) => LocalizedString} */
const ru_approve_request = en_approve_request;

/** @type {(inputs: Approve_RequestInputs) => LocalizedString} */
const pt_approve_request = en_approve_request;

/** @type {(inputs: Approve_RequestInputs) => LocalizedString} */
const ko_approve_request = en_approve_request;

/**
* | output |
* | --- |
* | "Approve" |
*
* @param {Approve_RequestInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const approve_request = /** @type {((inputs?: Approve_RequestInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Approve_RequestInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_approve_request(inputs)
	if (locale === "es") return es_approve_request(inputs)
	if (locale === "fr") return fr_approve_request(inputs)
	if (locale === "de") return de_approve_request(inputs)
	if (locale === "ja") return ja_approve_request(inputs)
	if (locale === "zh") return zh_approve_request(inputs)
	if (locale === "ar") return ar_approve_request(inputs)
	if (locale === "id") return id_approve_request(inputs)
	if (locale === "it") return it_approve_request(inputs)
	if (locale === "ru") return ru_approve_request(inputs)
	if (locale === "pt") return pt_approve_request(inputs)
	return ko_approve_request(inputs)
});